import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Building2, Percent, Wallet, BarChart3, FileBarChart, CalendarCheck, RefreshCw, Settings, LogOut, Trophy, ClipboardCheck, X } from 'lucide-react';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/users',     icon: Users,           label: 'User Management' },
  { to: '/venues',    icon: Building2,        label: 'Venue Partners' },
  { to: '/openplays', icon: Trophy,           label: 'Open Play' },
  { to: '/open-play-organiser-applications', icon: ClipboardCheck, label: 'Organiser Applications' },
  { to: '/commissions', icon: Percent,        label: 'Commission Settings' },
  { to: '/payouts',   icon: Wallet,           label: 'Payouts' },
  { to: '/analytics', icon: BarChart3,        label: 'Analytics' },
  { to: '/dupr', icon: Trophy, label: 'DUPR Integration' },
  { section: 'Reports' },
  { to: '/reports',   icon: FileBarChart,     label: 'Financial Report' },
  { to: '/reports/closing-position', icon: Wallet, label: 'Closing Position' },
  { to: '/reports/booking-details', icon: CalendarCheck, label: 'Booking Details' },
  { to: '/reports/payment-reconciliation', icon: RefreshCw, label: 'Payment Reconciliation' },
  { to: '/settings',  icon: Settings,         label: 'Settings' },
];

export default function AdminSidebar({ open, onClose, onLogout }) {
  return (
    <>
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm lg:hidden"
          onClick={onClose}
        />
      )}
      <aside
        className={`fixed top-0 left-0 z-50 h-full w-64 flex flex-col
          bg-[#264D59] shadow-[2px_0_8px_rgba(0,0,0,.10)]
          transform transition-transform duration-200 ease-in-out
          lg:translate-x-0 lg:static lg:z-auto
          ${open ? 'translate-x-0' : '-translate-x-full'}`}
      >
        {/* ── Brand header ── */}
        <div className="flex items-center justify-between h-20 px-5 border-b border-white/10">
          <div className="flex items-center gap-3">
            <img
              src="/Logo.png"
              alt="FREAC"
              className="w-10 h-10 rounded-xl object-cover"
            />
            <div>
              <h1 className="text-base font-bold text-white tracking-wide">FREAC</h1>
              <p className="text-xs text-white/60">Admin Portal</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="lg:hidden text-white/60 hover:text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* ── Navigation ── */}
        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
          {navItems.map((item) => item.section ? (
            <p key={item.section} className="px-3 pt-4 pb-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-white/40">
              {item.section}
            </p>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/dashboard' || item.to === '/reports'}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors duration-200
                ${isActive
                  ? 'bg-white/15 text-[#F9E07F] font-semibold'
                  : 'text-white/60 hover:text-white hover:bg-white/10'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <item.icon
                    size={18}
                    className={isActive ? 'text-[#F9E07F]' : 'text-white/40'}
                  />
                  {item.label}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* ── Logout ── */}
        <div className="p-3 border-t border-white/10">
          <button
            onClick={onLogout}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm
              font-medium text-white/60 hover:text-white hover:bg-white/10 transition-colors duration-200"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}
